export default class Application {
    returnModel() {
        return {
            id: null,
            uniqueCode: null,
            description: null,
            addDate: null,
            obsoleteDate: null
        }
    }
}